import { IReduxTeam } from "@gtmhub/teams/models/models";
import { Assignee } from "@webapp/assignees/models/assignee.models";
import { generateAssignees } from "@webapp/platform-intelligence/quantive-plus/utils/utils";
import { PIStateProcessorInstanceSubType } from "@webapp/platform-intelligence/shared/components/pi-feedback-card/services/state-processor/pi-state-processor.models";
import { MetricPropsRequiredForPiExistingMetricMap, MetricPropsRequiredForPiMetricMap } from "@webapp/platform-intelligence/shared/models/pi-kr.models";
import { ObjectivePropsRequiredForPiObjectiveMap } from "@webapp/platform-intelligence/shared/models/pi-objective.models";
import { mapMetricsToPiExistingKrs } from "@webapp/platform-intelligence/shared/utils/pi-adapter.utils";
import {
  QuantivePlusKeyResultsEffectivenessPayload,
  QuantivePlusObjectivesEffectivenessPayload,
  SuggestedEffectivenessTitle,
} from "../models/quantive-plus-effectiveness.models";

export function generateQuantivePlusObjectivesEffectivenessPayload({
  name,
  description,
  ownerIds,
  childrenOfKrType,
  assigneesIdMap,
  teams,
  refresh,
  accepted,
  rejected,
  entityId,
  subEntityType,
}: ObjectivePropsRequiredForPiObjectiveMap & {
  childrenOfKrType: MetricPropsRequiredForPiExistingMetricMap[];
  assigneesIdMap: Record<string, Assignee>;
  teams: IReduxTeam[];
  refresh: boolean;
  accepted: SuggestedEffectivenessTitle;
  rejected: SuggestedEffectivenessTitle;
  entityId: string;
  subEntityType: PIStateProcessorInstanceSubType;
}): QuantivePlusObjectivesEffectivenessPayload {
  const assignees = generateAssignees(ownerIds, assigneesIdMap, teams);
  const existingKrs = mapMetricsToPiExistingKrs(childrenOfKrType);

  return {
    entityId,
    subEntityType,
    refresh: refresh || false,
    refreshTitle: refresh || false,
    objectives: [
      {
        title: name,
        ...(description && { description }),
        assignees,
        existingKrs,
        accepted: {
          ...(accepted && { ...accepted }),
        },
        rejected: {
          ...(rejected && { ...rejected }),
        },
        ...(!refresh && { nSuggestions: 1 }),
      },
    ],
  };
}

export function generateQuantivePlusKeyResultsEffectivenessPayload({
  name,
  description,
  ownerIds,
  initialValue,
  target,
  actual,
  assigneesIdMap,
  teams,
  refresh,
  accepted,
  rejected,
  parentTitle,
  parentDescription,
  entityId,
  subEntityType,
}: MetricPropsRequiredForPiMetricMap & {
  assigneesIdMap: Record<string, Assignee>;
  teams: IReduxTeam[];
  refresh: boolean;
  accepted: SuggestedEffectivenessTitle;
  rejected: SuggestedEffectivenessTitle;
  parentTitle: string;
  parentDescription: string;
  entityId: string;
  subEntityType: PIStateProcessorInstanceSubType;
}): QuantivePlusKeyResultsEffectivenessPayload {
  const assignees = generateAssignees(ownerIds, assigneesIdMap, teams);

  return {
    entityId,
    subEntityType,
    refresh: refresh || false,
    refreshTitle: refresh || false,
    keyresults: [
      {
        krTitle: name,
        ...(description && { krDescription: description }),
        initialValue,
        targetValue: target,
        actualValue: actual,
        parentTitle,
        parentDescription,
        assignees,
        accepted: {
          ...(accepted && { ...accepted }),
        },
        rejected: {
          ...(rejected && { ...rejected }),
        },
        nSuggestions: 1,
      },
    ],
  };
}
